// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// SaveIowaVariationDetailsHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import IowaVariationDTO from '../models/IowaVariationDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    iowaVariationId: number;
    iowaVariation: IowaVariationDTO | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            iowaVariationId: 0,
            iowaVariation: null,
        },
        initValues);
    },
    iowaVariationId: 'iowaVariationId',
    iowaVariation: 'iowaVariation',
}

interface Result extends ResultDTO {
    iowaVariation: IowaVariationDTO | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            iowaVariation: null,
        },
        initValues);
    },
    iowaVariation: 'iowaVariation',
}

export { Request, Result };